"use strict";
/*
 * Copyright (C) 2024 Klaus Reimer <k@ailis.de>
 * See LICENSE.md for licensing information.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectAlignment = void 0;
/** Alignment to use for tile objects. */
var ObjectAlignment;
(function (ObjectAlignment) {
    ObjectAlignment["UNSPECIFIED"] = "unspecified";
    ObjectAlignment["TOPLEFT"] = "topleft";
    ObjectAlignment["TOP"] = "top";
    ObjectAlignment["TOPRIGHT"] = "topright";
    ObjectAlignment["LEFT"] = "left";
    ObjectAlignment["CENTER"] = "center";
    ObjectAlignment["RIGHT"] = "right";
    ObjectAlignment["BOTTOMLEFT"] = "bottomleft";
    ObjectAlignment["BOTTOM"] = "bottom";
    ObjectAlignment["BOTTOMRIGHT"] = "bottomright";
})(ObjectAlignment || (exports.ObjectAlignment = ObjectAlignment = {}));
//# sourceMappingURL=ObjectAlignment.js.map